import { numberType } from 'portal/src/components/common/forms/FormFieldTypes';

export const getFields = () => {
  const formFieldsConfiguration: Array<numberType> = [
    {
      allowNegative: true,
      label: 'Previous Reading',
      name: 'meterPreviousReading',
      placeholder: 'Previous Reading',
      type: 'number',
      required: false,
    },
    {
      allowNegative: true,
      label: 'Current Reading',
      name: 'meterCurrentReading',
      placeholder: 'Current Reading',
      type: 'number',
      required: false,
    },
    {
      allowNegative: true,
      label: 'Multiplier',
      name: 'meterReadingMultiplier',
      placeholder: 'Multiplier',
      infoTooltip:
        'This value defaults to the multipler value from the meter,' +
        ' it can be overridden at the line item level.',
      type: 'number',
      required: false,
    },
  ];

  return formFieldsConfiguration;
};
